import { BALANCE } from '../balance';
import { BATTLE_RULE_SET_ID } from '../rules/battleRuleSet';
import type { RuleOutcome } from '../rules/contracts';
import { GAME_MODE, type GameModeId, type MatchOutcome, type SeatIndex } from '../types';
import { BaseGameMode } from './BaseGameMode';
import type { GameModeDefinition } from './GameMode';

/**
 * One seat, one board, no opponent.
 *
 * One authoritative board and a two-minute score deadline. The battle rules
 * already behave as a score run when only one seat exists: there is no attack
 * target, while movement, combo, score and stalled-board recovery stay shared.
 */
export class SinglePlayerMode extends BaseGameMode {
  override readonly id: GameModeId = GAME_MODE.SOLO;
  override readonly requiredSeats: number = 1;
  override readonly roundDurationMs: number | null = BALANCE.phases.scoreAttackRoundMs;

  /** A solo run has no opponent, so it is never a "loss". */
  protected override outcomeForSeat(seat: SeatIndex, outcome: RuleOutcome): MatchOutcome {
    return outcome.winners.includes(seat) ? 'win' : 'draw';
  }
}

export const singlePlayerModeDefinition: GameModeDefinition = {
  id: GAME_MODE.SOLO,
  requiredSeats: 1,
  defaultRuleSetId: BATTLE_RULE_SET_ID,
  create: (ruleSetId = BATTLE_RULE_SET_ID) => new SinglePlayerMode(ruleSetId),
};
